// Form.jsx

import React, { useState } from "react";
import Button from "../Button/Button";
import "./Form.scss";

export default function Form({ value = [], setFormOpen, setMessage }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [buttonState, setButtonState] = useState(false);

  // Handle input changes
  const handleChange = (event) => {
    const { name, value } = event.target;

    // Dynamically update the state based on the field being changed
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    // Basic validation
    if (!formData.name || !formData.email) {
      alert("Please fill in all required fields.");
      return;
    }


    const dataToSend = {
      ...formData,
    };


    try {
      setMessage("");
      setButtonState(true);
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      const result = await res.json();
      setMessage(result);
      setTimeout(() => {
        setFormOpen(true);
        setButtonState(false);
        setFormData({ name: "", email: "", message: "" });
      }, 500);
    } catch (err) {
      console.error("Form submission error:", err);
      setMessage("There was a problem sending your message.");
      setButtonState(false);
    }
  };


  return (
    <form onSubmit={handleSubmit}>
      {value.map((row, rowIndex) => (
        <div className="row" key={`row-${rowIndex}`}>
          {row.map((field) => (
            <div className={field.col} key={field.name} style={field.style}>
              <label htmlFor={field.name} className="label">
                {field.label}
              </label>
              {field.type === "textarea" ? (
                <textarea
                  id={field.name}
                  name={field.name}
                  className="form-control"
                  value={formData[field.name]}
                  onChange={handleChange}
                />
              ) : (
                <input
                  id={field.name}
                  type={field.type}
                  name={field.name}
                  className="form-control"
                  value={formData[field.name]}
                  onChange={handleChange}
                />
              )}
            </div>
          ))}
        </div>
      ))}
      <Button name="Submit" loading={buttonState} variant={buttonState ? "loading" : "secondary"} />
    </form>
  );
}
